import { customTheme } from 'theme/MuiThemeProvider/theme';

export const styles = {
  wrap: {
    display: 'grid',
    borderRadius: '12px',
    border: `1px solid ${customTheme.custom.black.B10}`,
  },
};
